<template>
  <div class="wrap">
    <div class="container lnb">
      <div class="contents_wrap">
        <div class="contents">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
            <el-form-item label="제목 (최대16자)" prop="v_title">
              <el-input v-model="ruleForm.v_title"></el-input>
            </el-form-item>
            <el-form-item label="내용" prop="v_content">
              <el-input type="v_content" id="v_content"  v-model="ruleForm.v_content" >
              </el-input>
            </el-form-item>
            <el-form-item label="유투브 링크 ex) LUQcHoTIaZo" >
              <el-input v-model="ruleForm.v_link" ></el-input>
            </el-form-item>
            <el-form-item label="사용여부" prop="v_is_use">
              <el-radio-group v-model="ruleForm.v_is_use" style="width:100%;">
                <el-radio-button label="1">예</el-radio-button>
                <el-radio-button label="0" >아니오</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <div class="small_txt">
                <input type="file" id="filename"  class="file_input" ref="filename" multiple="multiple" style="display:none;"
                       v-on:change="setFile()"
                />
                <div class="input_file label_div"

                >
                  파일 추가 (최소넓이 630px , 비율:2:1)
                </div>
                <el-button  @click="selectFile()">
                  파일 추가
                </el-button>
                <div class="el-form-item__error" v-show="file_required">
                  필수 입력사항입니다.
                </div>
                <div class="files"
                     v-for="(item, index) in file"
                >
                  <div class="file_name">
                    {{item.name}}&nbsp;&nbsp;&nbsp;&nbsp;
                    <el-button
                      size="mini"
                      type="danger"
                      @click="deleteFile(index, item)">삭제</el-button>
                  </div>

                </div>
              </div>
            </el-form-item>
            <el-form-item class="text-center">
              <el-button type="primary" @click="submitForm('ruleForm')">{{ v_idx ? '수정' : '등록' }}</el-button>
              <el-button @click="resetForm('ruleForm')">목록</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import VuxAlert from '@/mixins/vux-alert';
  import util from '@/mixins/util';
  import sessionStorage from '@/mixins/sessionStorage';

  export default {
    name: "MethodCreate",
    components: {},
    mixins: [ VuxAlert ,sessionStorage],
    data() {
      return {
        userInfo : this.getUserInfo(),
        l_idx : 1,
        category : [],
        v_idx : this.$route.params.v_idx,
        ruleForm: {
          v_title: '',
          v_content: '',
          v_link: '',
          v_is_use: 1
        },
        rules: {
          v_title: [
            { required: true, message: '필수 입력사항입니다.',trigger: 'blur' },
            { min: 1, max: 16, message: '16이내로 입력해주세요', trigger: 'blur' }
          ],
          v_content: [
            { required: true, message: '필수 입력사항입니다.', trigger: 'blur' }
          ],
          v_is_use: [
            { required: true, message: '필수 입력사항입니다.', trigger: 'blur' }
          ],

        },
        file : [],
        file_required : false
      };
    },
    mounted() {
      this.getCountryCode();
      this.getCountryList();
      this.initSummernote();
      this.getMethodDetail();
    },

    methods: {
      initData() {
        this.ruleForm = {
          v_title: '',
          v_content: '',
          v_link : '',
          v_is_use: 1
        };
        this.v_idx = this.$route.params.v_idx;
        this.file = [];
        this.file_required = false;
      },
      getCountryCode(){
        if(this.userInfo.g_idx === 2){
          this.c_idx = this.userInfo.c_idx;
          this.getLanguageCode();
        }
      },
      getLanguageCode() {
        let params = {
          cid: this.userInfo.c_idx
        }
        this.$api.$user.getLanguageCountryList(params).then(res => res.Data.Result).then(res => {
          if(res.Info.Type === 1) {
            this.l_idx = 1;
          }
        })
      },
      getCountryList(){
        this.$api.$user.getLanguage()
          .then(res => { // 로그인 api 통신 후 결과 처리
            //let resultData = res.Data.result;
            // this.category = [{c_idx : 1 , CO_NAME_KOR : 'South Korea'},{c_idx : 2 , CO_NAME_KOR : 'Japan'}];
            this.category = res.Data.Result.List;
          });
      },
      initSummernote() {
        let $this = this;
        $('#v_content').summernote({
          height: 346,
          lang: 'ko',
          placeholder: '사용법을 입력해주세요',
          disableResizeEditor: true,
          callbacks: {
            onChange: function() {
              $this.ruleForm.v_content = $('#v_content').summernote('code');
            },
            onImageUpload: function(files, editor, welEditable) {
              let formData = new FormData();
              formData.append('files', files[0]);
              $this.$api.$file.editorUpload(formData).then(res => {
                if(res.status === true){
                  let dom = document.createElement('img');
                  $(dom).attr('src', 'http://'+res.file_name);
                  $('#v_content').summernote('insertNode', dom);
                }else{
                  status = res.reason;
                }
              })
            }
          }
        });
      },

      getMethodDetail(){
        if(this.v_idx){
          const params = {  id : this.v_idx }
          this.$api.$method.getMethod(params).then( res => res.Data.Result).then(res => {
            if(res.Info.Type === 1){
              let detail = res.List[0];
              this.ruleForm = {
                v_title: detail.v_title,
                v_content: detail.v_content,
                v_link: detail.v_link,
                v_is_use: detail.v_is_use,
              }
              this.l_idx = detail.l_idx;
              util.each(detail.File, (item, index, allItems) => {
                this.$set(this.file, this.file.length, {
                  name: item.org_name,
                  data: item.thumb_url,
                  a_idx : item.a_idx
                });
              });

              $('#v_content').summernote('code', util.htmlDecode(detail.v_content));
            }else{
              this.errorAlert("데이터 없음");
            }

          })
        }
      },

      async submitForm(formName) {
        await this.$refs[formName].validate((valid) => {
          if(util.isEmpty(this.file)) {
            this.file_required = true;
            this.validateAlert();
            return false;
          }
          if (valid) {
            let params = this.ruleForm;
            this.ruleForm.v_idx = this.v_idx;
            this.ruleForm.l_idx = this.l_idx;
            if(this.ruleForm.v_idx){
              this.$api.$method.updateMethod(params).then( res => res.Data.Result).then(res => {
                if(res.Info.Type === 1){
                  if(this.file.length !== 0){
                    this.file_required = false;
                    this.updateFile(this.v_idx);
                  }else{
                    this.file_required = true;
                  }
                }else{
                  this.errorAlert("수정실패");
                }
              })
            }else{
              this.$api.$method.setMethod(params).then( res => res.Data.Result).then(res => {
                if(res.Info.Type === 1){
                  if(this.file.length !== 0){
                    this.file_required = false;
                    this.updateFile(res.List);
                  }else{
                    this.file_required = true;
                  }
                }else{
                  this.errorAlert("등록실패");
                }
              })
            }
          } else {
            this.validateAlert();
            return false;
          }
        });
      },

      setFile() {
        let fileNmae = $('#filename').val();
        let count = 0;
        fileNmae = fileNmae.split('\\');

        const file = this.$refs.filename.files;

        util.each(this.file, (item, index, allItems) => {
          if(item.name === fileNmae[2]){
            $('#filename').val('');
            return;
          }
          if(item.name){
            count++
          }
        });
        if(file.length > 1 - count) {
          this.$refs.filename.value = '';
          this.errorAlert('파일은 하나만 등록가능합니다.');
          return;
        }
        util.each(file, (item, index, allItems) => {
          this.$set(this.file, this.file.length, {
            name: item.name,
            data: item
          });
        });
      },
      selectFile() {
        $(this.$refs.filename).trigger('click');
      },
      deleteFile(index,item) {
        let alertParams = {'element' : this , 'key' : item.a_idx , 'index' : index };
        this.fileDeleteAlert(alertParams);
      },

      apiFileDelete(index , key){
        if(key){
          let params = { 'a_idx' : key }
          this.$api.$file.deleteFile(params).then( res => res.Data).then(res => {
            if(res.status === true){
              this.$delete(this.file, index);
            }else{
              this.errorAlert(res.reason);
            }
          })
        }else{
          $('#filename').val('');
          this.file = [];
        }
      },

      async updateFile(v_idx){
        let status = 0;
        await util.each(this.file, (item, index, allItems) => {
          if(typeof item.data === 'object'){
            let formData = new FormData();
            formData.append('files', item.data);
            formData.append('v_idx', v_idx);
            formData.append('a_container_type', 'youtube');
            formData.append('a_container_id', v_idx);
            this.$api.$file.updateFile(formData).then( res => res.Data.Result).then(res => {
              if (res.Info.Type === 1) {
              } else {
                status = res.Info.reason;
              }
              //마지막 일때 컨펌
              if (this.file.length === index + 1) {
                this.confirmStatus(status);
              }
            })
          }else{
            this.updateAlert();
          }
        });
      },
      confirmStatus(status){
        if(status === 0){
          if(this.v_idx){
            this.updateAlert();
          }else{
            let alertParams = {'element' : this , 'editor' : true, 'id' : 'v_content'};
            this.saveAlert(alertParams);
          }
        }else{
          this.errorAlert(status);
        }
      },

      resetForm(formName) {
        window.history.back();
      }
    }
  }
</script>
